import styled from 'styled-components';

import Link from 'components/link';

export const StyledLink = styled(Link)`
  color: currentColor;
  font-family: ${Styles.fontFamily.base};
  font-size: 1.125rem;
  margin-left: 1.3rem;

  &.active,
  &:hover {
    text-decoration: none;
  }

  &:first-of-type {
    margin-left: 0;
  }
`;
